var SectionView = require( 'kitbuilder-views/section' ),
	BaseSectionsContainerView;

BaseSectionsContainerView = Marionette.CompositeView.extend( {
	childView: SectionView,

	behaviors: {
		Sortable: {
			behaviorClass: require( 'kitbuilder-behaviors/sortable' ),
			elChildType: 'section'
		},
		HandleDuplicate: {
			behaviorClass: require( 'kitbuilder-behaviors/handle-duplicate' )
		},
		HandleAdd: {
			behaviorClass: require( 'kitbuilder-behaviors/duplicate' )
		}
	},

	getSortableOptions: function() {
		return {
			handle: '> .kitbuilder-container > .kitbuilder-row > .kitbuilder-column > .kitbuilder-element-overlay .kitbuilder-editor-section-settings-list .kitbuilder-editor-element-trigger',
			items: '> .kitbuilder-section'
		};
	},

	getChildType: function() {
		return [ 'section' ];
	},

	isCollectionFilled: function() {
		return false;
	},

	initialize: function() {
		this
			.listenTo( this.collection, 'add remove reset', this.onCollectionChanged )
			.listenTo( kitbuilder.channels.panelElements, 'element:drag:start', this.onPanelElementDragStart )
			.listenTo( kitbuilder.channels.panelElements, 'element:drag:end', this.onPanelElementDragEnd );
	},

	addChildModel: function( model, options ) {
		return this.collection.add( model, options, true );
	},

	addSection: function( properties ) {
		var newSection = {
			id: kitbuilder.helpers.getUniqueID(),
			elType: 'section',
			settings: {},
			elements: []
		};

		if ( properties ) {
			_.extend( newSection, properties );
		}

		var newModel = this.addChildModel( newSection );

		return this.children.findByModelCid( newModel.cid );
	},

	onCollectionChanged: function() {
		kitbuilder.setFlagEditorChange( true );
	},

	onPanelElementDragStart: function() {
		kitbuilder.helpers.disableElementEvents( this.$el.find( 'iframe' ) );
	},

	onPanelElementDragEnd: function() {
		kitbuilder.helpers.enableElementEvents( this.$el.find( 'iframe' ) );
	}
} );

module.exports = BaseSectionsContainerView;
